module.exports = __webpack_public_path__ + "media/assets/charter-cb5ad14ee9fedc379d38a426eec75d73.png";